import { render, staticRenderFns } from "./tabPenggajian.vue?vue&type=template&id=3dbb4568&scoped=true"
import script from "./tabPenggajian.vue?vue&type=script&lang=js"
export * from "./tabPenggajian.vue?vue&type=script&lang=js"
import style0 from "./tabPenggajian.vue?vue&type=style&index=0&id=3dbb4568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb4568",
  null
  
)

export default component.exports